import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    ym?: (counterId: number, method: string, ...args: unknown[]) => void;
  }
}

const counterId = Number(process.env.REACT_APP_YANDEX_METRIKA_ID);

// The counter in public/index.html is initialized with defer:true, so page
// views are sent from here: once on load and again on every route change.
// window.ym exists only when the counter snippet was included in the build.
const YandexMetrikaPageViews = () => {
  const { pathname, search } = useLocation();
  const prevUrl = useRef<string | undefined>(undefined);

  useEffect(() => {
    const url = window.location.origin + pathname + search;

    window.ym?.(counterId, 'hit', url, { referer: prevUrl.current });
    prevUrl.current = url;
  }, [pathname, search]);

  return null;
};

export default YandexMetrikaPageViews;
